import { render, staticRenderFns } from "./CatalogueBreadcrumb.vue?vue&type=template&id=5f46447e"
import script from "./CatalogueBreadcrumb.vue?vue&type=script&lang=js"
export * from "./CatalogueBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports